// import { useState } from 'react'
import dynamic from 'next/dynamic';
import JournalWideMedia from './JournalWideMedia'
import JournalWideText from './JournalWideText'

const UserButtons = dynamic(() => import('../journal/UserButtons.tsx').then(x => x.default), { ssr: false })
const JRNAdminFloat = dynamic(() => import('../admin/Journal/JRNAdminFloat.tsx').then(x => x.default), { ssr: false })


import Component, { PageEl } from '@/frontend/components/qecomps/Component'
import WindowFloat from '../qecomps/WindowFloat';
export default p => Component(p, Page);
const Page: PageEl = (props: {} & { [key: string]: any }, refresh, getProps, onLoad, onConnected, dies, isFront, z) => {

  props.item.isadmin = z.user.role.includes("admin")
  props.item.isowner = z.user.uid == props.item.uid

  return <>
    {props.form == "admin" && z.user.role.includes("admin") ? <JRNAdminFloat item={props.item} onclose={() => refresh({ form: null })} /> : null}
    {z.user.role.includes("admin") && props.form == "votechanger" ?
      <WindowFloat title="نتیجه رای" onclose={() => { refresh({ form: null }) }} z={100}>
        <f-cc>
          <g-b style={{ flex: 1 }} onClick={async () => {
            let num = await prompter("ستاره‌ها", " تعداد ستاره‌ها را وارد کنید", 5, true, props.item.stars);
            if (num && !isNaN(Number(num))) {
              let json = await API["journal/valueeditor"]({
                property: "stars",
                value: Number(num),
                jid: props.item.jid
              })

              if (json.code == 0) {
                // global.reload()
                props.item.stars = Number(num)
                props.form = null
                refresh()
              }
            }
          }}><f-12>تغییر نتیجه</f-12></g-b>
          <sp-3 />
          <g-b style={{ flex: 1 }} onClick={async () => {

            let num = await prompter("تعداد رای", "تعداد رای گیری را وارد کنید", 10, true, props.item.voterscount);
            if (num && !isNaN(Number(num))) {

              let json = await API["journal/valueeditor"]({
                property: "voterscount",
                value: Number(num),
                jid: props.item.jid
              })

              if (json.code == 0) {
                props.item.voterscount = Number(num)
                props.form = null
                refresh()
              }
            }
          }}><f-12>تغییر تعداد</f-12></g-b>
        </f-cc>
      </WindowFloat> : null}


    <div className={z.styles.expside} style={{ direction: "ltr" }}>
      <JournalWideMedia item={props.item} interval={props.interval} items={props.items}
        index={props.index} showall={props.showall} onreload={(e) => props.onreload?.(e)}
        onviewclick={async () => {
          if (z.user.role.includes("admin")) {
            let num = await prompter("ویوو", "تعداد ویو", 20, false, props.item.views)
            if (num && !isNaN(Number(num))) {

              let json = await API["journal/valueeditor"]({
                property: "views",
                value: parseInt(num),
                jid: props.item.jid
              })

              if (json.code == 0) {
                props.item.views = parseInt(num)
                refresh()
              }
            }
          }

        }}
        onplzvote={() => { refresh({ form: "votechanger" }) }}
        onzclick={async () => {
          if (z.user.role.includes("admin")) {
            let num = await prompter("تغییر ایندکس", " ایندکس زد را به صورت عدد وارد کنید", null, false, props.item.z)
            if (num && !isNaN(Number(num))) {

              let json = await API["journal/valueeditor"]({
                property: "z",
                value: parseInt(num),
                jid: props.item.jid
              })

              if (json.code == 0) {
                props.item.z = parseInt(num)
                refresh()
              }
            }
          }
        }}
        ondateclick={() => {
          if (z.user.role.includes("admin")) {
            refresh({ form: "admin" })
          }
        }}
      />
      <JournalWideText item={props.item} interval={props.interval} items={props.items} iswide={props.iswide}
        index={props.index} showall={props.showall} oncomments={() => { props.oncomments?.() }}
        onnameclick={(uid) => { props.onnameclick?.(uid) }} onavatarclick={(uid) => { props.onavatarclick?.(uid) }} >


        <UserButtons iswide={props.iswide} item={props.item} items={props.items}
          index={props.index} onreload={() => refresh()} oncomments={() => { props.oncomments?.() }} />
          
      </JournalWideText>
    </div>
    </>
}